import React, { FC, useEffect, useState } from "react";
import styled from "styled-components";

interface IRadio {
  name: string;
  value: string | boolean;
  label: string | React.ReactNode;
  id?: string;
  tabIndex?: number;
  isChecked?: boolean;
  onChange?: (arg: string | boolean) => void;
  onBlur?: (id: string, value: string | boolean) => void;
  type?: string;
}

const StyledRadio = styled.label<{ for?: string }>`
  display: flex !important;
  align-items: center;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5em;
  color: var(--text);
  cursor: pointer;
  @media only screen and (max-width: 768px) {
    font-size: 14px;
  }
`;

const StyledCustomRadio = styled.span<{ isChecked: boolean }>`
  position: relative;
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-right: 15px;
  cursor: pointer;
  background-color: ${({ isChecked }) =>
    isChecked ? "var(--radio-background-selected)" : "var(--color-white)"};
  border: 1px solid;
  border-color: ${({ isChecked }) =>
    isChecked ? "rgba(112, 112, 112, 0.3)" : "rgba(0, 0, 0, 0.3)"};

  border-radius: 50%;
  transition: 0.4s;
  aspect-ratio: 1/1;

  &::before {
    content: "";
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate3d(-50%, -50%, 0) scale(0);
    display: block;
    width: 16px;
    height: 16px;
    background-color: ${({ isChecked }) =>
      isChecked ? "var(--radio-inner-background-selected)" : "var(--primary)"};
    border: 1px solid;
    border-color: ${({ isChecked }) =>
      isChecked ? "rgba(112, 112, 112, 0.3)" : "transparent"};
    border-radius: 50%;
    transition: 0.4s;
  }
`;

const StyledRadioInput = styled.input`
  position: absolute;
  width: 0.1px;
  height: 0.1px;
  z-index: -1;
  opacity: 0;
  transition: 0.4s;

  &:hover + span,
  &:focus + span {
    border-color: var(--primary);
  }

  &:checked + ${StyledCustomRadio}::before {
    transform: translate3d(-50%, -50%, 0) scale(1);
  }
`;

const Radio: FC<IRadio> = (props): JSX.Element => {
  const {
    id,
    name,
    value,
    tabIndex,
    label,
    isChecked = false,
    onBlur,
    onChange,
    type = "radio",
  } = props;

  const [radioValue, setRadioValue] = useState<any>(value);

  useEffect(() => setRadioValue(value), [value]);

  const handlerChange = (e: React.FormEvent<HTMLInputElement>) => {
    const radioValue: string = e.currentTarget.value;

    setRadioValue(() => radioValue);
    if (!onChange) return;

    if (radioValue === "true") {
      onChange(true);
      return;
    }
    if (radioValue === "false") {
      onChange(false);
      return;
    }
    onChange(radioValue);
  };

  return (
    <StyledRadio>
      <StyledRadioInput
        checked={isChecked}
        type={type}
        tabIndex={tabIndex}
        name={name}
        value={radioValue}
        onBlur={() => onBlur && onBlur(id || "", radioValue)}
        // onClick={handlerChange}
        onChange={handlerChange}
        onKeyDown={(event) => {
          event.code === "Enter" && handlerChange(event);
        }}
      />
      <StyledCustomRadio isChecked={isChecked} />
      {label}
    </StyledRadio>
  );
};

export default Radio;
